/**
* Service Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Service Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'service-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.service-hero' ).each( function( key, component ) {
        if ( $( component ).find( '.splide--service-hero' ).length ) {
          const splide = new Splide( $( component ).find( '.splide--service-hero' )[0], {
            pagination: true,
            arrows: false,
            gap: '32px',
            perPage: 1,
            perMove: 1,
          } );

          splide.mount();
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'service-hero', COMPONENT );
} )( app );
